import {
  Card,
  CardContent,
} from "@arcadeai/design-system/components/ui/atoms/card";
import { Link } from "@tanstack/react-router";
import type { LucideIcon } from "lucide-react";
import type { FileRoutesByTo } from "@/routeTree.gen";

type MetricWidgetProps = {
  title: string;
  value: number | string;
  icon: LucideIcon;
  href: keyof FileRoutesByTo;
};

export function MetricWidget({
  title,
  value,
  icon: Icon,
  href,
}: MetricWidgetProps) {
  return (
    <Link className="w-full" to={href}>
      <Card className="bg-card py-4 transition-all duration-200 hover:bg-neutral-100 hover:shadow-md dark:hover:bg-neutral-900">
        <CardContent className="px-4">
          <div className="flex items-center justify-between">
            <h3 className="font-medium text-base dark:text-zinc-300">
              {title}
            </h3>
            <Icon className="size-4 dark:text-zinc-300" />
          </div>
          <div className="mt-1">
            <div className="font-semibold text-2xl text-foreground tracking-tight">
              {value}
            </div>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
